import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Tooltip } from '../../../Tooltip';
import { Badge } from '../../../Badge';
import { AppIconContainer, BadgeContainer } from '../ChipLabel.style';

export const MultiAppSelectLabel = ({
  chipDefaultValue,
  value: values,
  disabled,
  maxSelectedItemsToDisplay = 2,
  LabelTooltipProps,
  CounterBadgeProps
}) => {
  const theme = useTheme();

  if (!values || values.length === 0) {
    return chipDefaultValue;
  }

  if (values.length <= maxSelectedItemsToDisplay) {
    return (
      <span>
        {values?.map(value => (
          <Tooltip
            title={value.label}
            key={value.value}
            data-qa-value={value.label}
            spacing={theme.spacing(0.75)}
            {...LabelTooltipProps}>
            <AppIconContainer disabled={disabled}>
              {value?.renderIcon &&
                value.renderIcon({
                  size: 'small'
                })}
            </AppIconContainer>
          </Tooltip>
        ))}
      </span>
    );
  }

  const visibleLabels = values.slice(0, maxSelectedItemsToDisplay);
  const tooltipContent = values.map(({ label }) => label).join(', ');
  const badgeContent = values.length - maxSelectedItemsToDisplay;

  return (
    <Tooltip
      title={tooltipContent}
      data-qa-value={tooltipContent}
      spacing={theme.spacing(1)}
      {...LabelTooltipProps}>
      <span>
        {visibleLabels.map(value => (
          <AppIconContainer key={value.value} disabled={disabled}>
            {value.renderIcon &&
              value.renderIcon({
                size: 'small'
              })}
          </AppIconContainer>
        ))}
        <BadgeContainer disabled={disabled}>
          <Badge
            badgeContent={badgeContent}
            variant="counter"
            color="primary"
            max={Infinity}
            {...CounterBadgeProps}
          />
        </BadgeContainer>
      </span>
    </Tooltip>
  );
};
